import { Container } from "pixi.js";

import { Tween } from "tweedle.js";
import { AbstractDisplayComponent } from "../../core/displays/AbstractDisplayComponent";
import { Manager } from "../../core/Manager";
import { Logo } from "./Logo";

export class LogoComponent extends AbstractDisplayComponent {
    public container: Container;
    // private yPosRIPFeature: number = 675;
    private resetYPosRIPFeature: number = 325;

    public override init() {
        let containerConfig = {
            labelName: "logo_container",
            anchorX: 0.5,
            anchorY: 0.5,
            landscape: {
                posX: 250,
                posY: 650,
                scale: 1,
            },
            portrait: {
                posX: 1024,
                posY: 325,
                scale: 1,
            }
        };

        this.container = new Logo(containerConfig);
    }

    public getInstance(): Container {
        return this.container;
    }

    public override destroy(): void {
        this.container.destroy({ children: true });
    }

    public setLogoPositionDuringRIPFeature(): void {
        super.init();
        // if(Manager.Orientation === "PORTRAIT"){
        //     new Tween(this.container)
        //     .to({ y: this.yPosRIPFeature }, 1000)
        //     .start();
        //     // this.container.position.y = this.yPosRIPFeature;
        // }
    }

    public resetLogoPositionAfterRIPFeature() {
        super.init();
        if (Manager.Orientation === "PORTRAIT") {
            new Tween(this.container)
                .to({ y: this.resetYPosRIPFeature }, 1000)
                .start();
            // this.container.position.y = this.resetYPosRIPFeature;
        }
    }
}
